import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import Heading from '../Heading';
import InnerWrapper from '../../global/InnerWrapper';
import ItemCard from '../../global/ItemCard';

const ItemWrapper = styled.div`
  flex: 1 0 auto;
  margin: 0 0 30px 0;

  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    margin: 0 10px 0 0;
    max-width: 80vw;
    flex: 1 0 auto;
  }

  @media (min-width: ${props => props.theme.deviceWidth.largePhone}) {
    flex: 0 0 calc(50% - 5px);
    margin: 0;

    &:nth-child(2n) {
      margin: 0 0 0 10px;
    }

    &:nth-child(n + 3) {
      margin-top: 10px;
    }
  }

  @media (min-width: ${props => props.theme.deviceWidth.tablet}) {
    flex: 0 0 25%;
    max-width: calc(25% - 3.75px);

    &:nth-child(2n),
    &:nth-child(n + 3) {
      margin-top: 0;
      margin: 0;
    }

    &:not(:last-child) {
      margin: 0 5px 0 0;
    }
  }

  & > * {
    height: 100%;
    max-width: 100%;
  }
`;

const ProductsWrapper = styled.div`
  display: flex;

  @media (max-width: ${props => props.theme.deviceWidth.tablet}) {
    flex-wrap: wrap;
  }

  @media (max-width: ${props => props.theme.deviceWidth.largePhone}) {
    flex-wrap: nowrap;
    overflow-x: scroll;
  }
`;

const RelatedProductsSection = ({ products }) => (
  <InnerWrapper>
    <Heading hideOnMobile>Related Products</Heading>
    <ProductsWrapper>
      {products.slice(0, 4).map(p => (
        <ItemWrapper key={p.id}>
          <ItemCard
            archived={p.archived}
            category={p.class ? p.class.name : null}
            count={p.modelCount}
            countDesc="Model"
            description={p.description}
            image={p.image}
            path={`/products/${p.class.slug}/${p.slug}`}
            singleLineTitle
            title={p.name}
          />
        </ItemWrapper>
      ))}
    </ProductsWrapper>
  </InnerWrapper>
);

RelatedProductsSection.propTypes = {
  products: PropTypes.arrayOf(PropTypes.object).isRequired
};

export default RelatedProductsSection;
